import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Triangle: React.FC<SVGProps<SVGSVGElement>> = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.13405 5.5C9.51895 4.83333 10.4812 4.83333 10.8661 5.5L15.1962 13C15.5811 13.6667 15.1 14.5 14.3302 14.5H5.66995C4.90015 14.5 4.41902 13.6667 4.80392 13L9.13405 5.5Z"
        fill="#356DFF"
      />
    </svg>
  )
}

Triangle.displayName = 'Triangle'

export default withIcon(Triangle)
